import type { MegaMenuFeaturedContent } from "@/features/navigation/components/MegaMenu/types/megaMenu.types";
import { cn } from "@/shared/utils/style.util";

type MegaMenuFeaturedCardProps = { content: MegaMenuFeaturedContent };

export const MegaMenuFeaturedCard = ({ content }: MegaMenuFeaturedCardProps) => {
  return (
    <div className="row-span-3">
      <div
        className={cn(
          "relative h-full w-full flex flex-col justify-end",
          "rounded-xl p-6 overflow-hidden",
          "bg-gradient-to-br shadow-lg",
          content.gradient,
          "transition-shadow duration-300",
          "hover:shadow-xl",
          "group",
        )}
      >
        {/* Gradient overlay for better text readability */}
        <div className="absolute inset-0 bg-gradient-to-t from-black/40 via-black/20 to-transparent" />

        {/* Animated background pattern */}
        <div className={cn(
          "absolute inset-0 opacity-20",
          "bg-[radial-gradient(circle_at_50%_120%,rgba(255,255,255,0.3),transparent)]",
          "group-hover:opacity-30 transition-opacity duration-300",
        )}
        />

        {/* Content */}
        <div className="relative z-10 space-y-2">
          <div className="text-lg sm:text-xl font-bold text-white">
            {content.title}
          </div>
          <p className="text-sm text-white/90 leading-relaxed max-w-[300px]">
            {content.description}
          </p>
        </div>

        {/* Decorative element */}
        <div className={cn(
          "absolute -right-8 -bottom-8 w-32 h-32 rounded-full",
          "bg-white/10 blur-2xl",
          "transition-opacity duration-500",
        )}
        />
      </div>
    </div>
  );
};
